export const SET_ALL = 'SET_ALL';
export const SET_NOTIFICATION_LOADING = 'SET_NOTIFICATION_LOADING';
export const ADD_NOTIFICATIONS_FROM_WS = 'ADD_NOTIFICATIONS_FROM_WS';
export const ADD_NOTIFICATIONS_FROM_API = 'ADD_NOTIFICATIONS_FROM_API';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const SET_NOTIFICATION_AS_READ = 'SET_NOTIFICATION_AS_READ';
export const SET_ALL_NOTIFICATIONS_AS_READ = 'SET_ALL_NOTIFICATIONS_AS_READ';
export const LESS_NOTIFICATIONS = 'LESS_NOTIFICATIONS';
